<template>
  <button
    v-b-popover.top.click="popoverOptions"
    type="button"
    class="information-popover"
    :aria-label="ariaLabel"
    @click.stop
  >
    <i class="fal fa-info-circle" aria-hidden="true"></i>
  </button>
</template>

<script>
export default {
  name: "InformationPopover",

  computed: {
    popoverOptions() {
      return {
        content: this.content,
        customClass: "information-popover-content",
      };
    },
  },

  props: {
    content: {
      type: String,
      required: true,
    },
    ariaLabel: {
      type: String,
      default: "További információ",
    },
  },
};
</script>

<style scoped>
.information-popover {
  align-items: center;
  background: transparent;
  border: 0;
  color: #252734;
  display: inline-flex;
  font-size: 14px;
  justify-content: center;
  line-height: 1;
  margin: 0;
  padding: 0;
}

.information-popover:focus {
  border-radius: 50%;
  box-shadow: 0 0 0 3px rgba(178, 236, 93, 0.7);
  outline: none;
}
</style>

<style>
.information-popover-content.popover {
  max-width: calc(100vw - 32px) !important;
  width: max-content !important;
}

.information-popover-content .popover-body {
  white-space: nowrap;
}

@media (max-width: 768px) {
  .information-popover-content .popover-body {
    white-space: normal;
  }
}
</style>
